export default __webpack_public_path__ + "static/media/Certified-Protocols.af0d24bd.png";